import transformer from '@/services/bodac/besoin/transformer';
import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/Besoin/';

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function updateAll(payload) {
  const response = await HTTP.put(URL_BASE + 'UpdateAllAsync', payload);
  return response;
}

export async function createAll(payload) {
  const response = await HTTP.post(URL_BASE + 'CreateAllAsync', payload);
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function generationBesoinAsync(payload) {
  const response = await HTTP.post(URL_BASE + 'GenerationBesoinAsync', payload);
  return response;
}

export async function deleteAll(payload) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllAsync', payload);
  return response;
}

export async function duplicateAll(payload) {
  const response = await HTTP.post(URL_BASE + 'PDuplicateAllAsync', payload);
  return response;
}

export async function genererCommandeAchatAll(payload) {
  const response = await HTTP.post(URL_BASE + 'GenerationCommandeAsync', payload);
  return response;
}
export async function updateBesoinFields(payload) {
  const response = await HTTP.post(URL_BASE + 'PUpdateBesoinFieldsAsync', payload);
  return response;
}
